import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@gx-design/tag';

export const FILE_TYPE = 'file';
export const PHOTO_TYPE = 'photo';
export const VIDEO_TYPE = 'video';

export const AttachmentTag = ({ type, count, onCloseClick, onClick }) => {
    const getTextAndIcon = () => {
        switch (type) {
            case FILE_TYPE:
                return {
                    text: 'File',
                    icon: 'docs',
                };
            case PHOTO_TYPE:
                return {
                    text: 'Foto',
                    icon: 'image',
                };
            case VIDEO_TYPE:
                return {
                    text: 'Video',
                    icon: 'video',
                };
            default:
                return {
                    text: 'Foto',
                    icon: 'image',
                };
        }
    };

    return (
        <Tag
            dismissable
            icon={type && getTextAndIcon().icon}
            text={`${count ?? ''} ${getTextAndIcon().text}`}
            onCloseClick={onCloseClick}
        />
    );
};

AttachmentTag.propTypes = {
    type: PropTypes.oneOf(['file', 'photo', 'video']),
    count: PropTypes.number,
    onCloseClick: PropTypes.func,
    onClick: PropTypes.func,
};
